import { useSearchParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { PageHeader } from "@/components/control/PageHeader";
import { Tabbar, TabPanel, useTabs } from "@/components/control/kit";
import { Team, Roles } from "@/pages/Settings";
import { OrgRightsMatrix } from "@/pages/OrgRights";

const VIEWS = { team: Team, rollen: Roles, organisation: OrgRightsMatrix };

export default function TeamRights() {
  const [params, setParams] = useSearchParams();
  const tabs = useTabs([{ value: "team", label: "Team" }, { value: "rollen", label: "Rollenrechte" }, { value: "organisation", label: "Organisationsrechte" }], params.get("tab"));
  const View = VIEWS[tabs.value];
  return (
    <div>
      <PageHeader title="Team & Rechte" subtitle="Individuelle Teamkonten, serverseitig festgelegte Rollen und begrenzte Organisationsrechte." icon={ShieldCheck} />
      <Tabbar tabs={tabs} onChange={(v) => setParams({ tab: v })} testId="team-rights-tabs" />
      <TabPanel tabs={tabs} testId="team-rights-panel"><View /></TabPanel>
    </div>
  );
}
